<template>
  <div>
    <div
      v-if="showTitle"
      class="mx-4 font-bold flex items-center red-dot justify-between"
    >
      人员
    </div>
    <div class="flex gap-3 px-4 my-2 text-xs">
      <div v-if="members.length === 0">
        <button
          class="btn btn-outline btn-xs self-center aspect-[3/4] w-14 h-full"
          @click.stop="clickAddLeader"
        >
          {{ $t(`mission.mate.addLeader`) }}
        </button>
      </div>
      <div
        v-else
        class="flex flex-col w-14 items-center gap-1 relative"
        v-for="item in members"
        :key="item?.id"
        @click.stop="clickMember(item)"
      >
        <button
          class="absolute top-3 -right-3 z-[1]"
          v-if="isEdit && !isSelect"
          @click.stop="clickRemoveMember(item)"
        >
          <i class="iconify mingcute--close-circle-fill"></i>
        </button>
        <p class="font-bold">
          {{
            item.type === DispatchMemberType.Leader ||
            item.mate?.id === activeMate?.id
              ? $t(`mission.mate.leader`)
              : $t(`mission.mate.follow`)
          }}
        </p>
        <UserAvatar class="w-full" :mate="item.mate" />
        <p class="line-clamp-1">{{ useName(item.mate!.name) }}</p>
        <template
          v-if="
            [
              DispatchStatus.Preparing,
              DispatchStatus.AwaitingInviteeResponse,
            ].includes(dispatchMission.status!) &&
            item.settlementStatus === 1 &&
            item.invitation
          "
        >
          <p
            class="text-info"
            v-if="item.invitation.status === InvitationStatus.Pending"
          >
            等待响应
          </p>
          <p
            class="text-success"
            v-else-if="item.invitation.status === InvitationStatus.Accepted"
          >
            已接受
          </p>
          <p
            class="text-error"
            v-else-if="item.invitation.status === InvitationStatus.Rejected"
          >
            已拒绝
          </p>
        </template>
        <template v-else-if="showAction">
          <!-- MissionEdit -->
          <template
            v-if="
            type !== 'retry' &&
            mateStore.isMyMateById(item.mateId) &&
            [DispatchStatus.Returned, DispatchStatus.Settled].includes(
              dispatchMission.status!
            )"
          >
            <button
              v-if="item.settlementStatus === SettlementStatus.Pending"
              class="btn btn-primary btn-xs whitespace-nowrap"
              @click.stop="clickSettle(item)"
            >
              {{ $t(`mission.statusBtnMap.3`) }}
            </button>
            <button
              v-if="item.settlementStatus === SettlementStatus.Settled"
              class="btn btn-xs whitespace-nowrap"
              @click.stop="clickToDetail(item)"
            >
              {{ $t(`interactive.reviewPage.goToView`) }}
            </button>
          </template>
          <template
            v-else-if="
              !mateStore.isMyMateById(item.mate?.id) &&
              (isEdit || type === 'retry')
            "
          >
            <div
              class="flex flex-col items-center gap-1"
              @click.stop="clickPayerType(item)"
            >
              <VanSwitch
                :model-value="item.payerType"
                :active-value="DispatchMemberPayerType.Host"
                size="12"
              />
              <span>帮他付</span>
            </div>
          </template>
        </template>
        <button
          v-else-if="type === 'rank'"
          class="btn btn-xs whitespace-nowrap"
          @click.stop="clickToDetail(item)"
        >
          {{ $t(`interactive.reviewPage.goToView`) }}
        </button>
      </div>
      <div
        v-if="
          isEdit &&
          dispatchMission.type === DispatchType.Mission &&
          activeMate?.id &&
          (dispatchMission.dispatchMemberzz?.length || 0) < 3
        "
        class="flex flex-col items-center gap-1"
      >
        <p class="opacity-0">tmp</p>
        <button
          class="btn btn-outline btn-xs w-14 h-[74px] h- leading-4"
          @click.stop="clickAddMember"
        >
          {{ $t(`mission.mate.addFollow`) }}
        </button>
      </div>
    </div>

    <div
      v-if="
        payerHtml ||
        (isEdit &&
          dispatchMission.dispatchMemberzz?.some(
            (v) => v.type === DispatchMemberType.OthersCharacter
          ) &&
          !isSelect)
      "
      class="mx-4 flex flex-col gap-1 mb-2 bg-base-200 px-4 py-2"
    >
      <div v-if="payerHtml" v-html="payerHtml"></div>
      <div v-else>
        <p class="text-xs text-base-content/80">
          开启帮他付后，对方接受任务时，将不用支付能量块
        </p>
      </div>
    </div>

    <ModalFriendMateSelect
      v-model:show="showFriendMateSelect"
      :sender="activeMate"
      :exclude="exclude"
      @select="onFriendMateSelect"
      show-my-mate
    />
  </div>
</template>

<script setup lang="ts">
import { Mate, MateDispatch, MateDispatchMember } from "@/types/entity";
import { computed, onMounted, ref, watch } from "vue";
import { useName } from "@/use/common";
import {
  DispatchStatus,
  DispatchType,
  InvitationStatus,
} from "@/enums/mission";
import { useMate } from "@/stores/mate";
import {
  DispatchMemberPayerType,
  DispatchMemberType,
  SettlementStatus,
} from "@/enums/mateEnums";
import { useRoute, useRouter } from "vue-router";
import { useUI } from "@/stores/ui";
import { showLoadingToast } from "vant";
import { useMission } from "@/stores/mission";
import { useI18n } from "vue-i18n";
import { checkAndInitObjective } from "./MissionGenerate";
const mateStore = useMate();
const router = useRouter();

const props = withDefaults(
  defineProps<{
    dispatchMission: Partial<MateDispatch>;
    isEdit: boolean;
    activeMate?: Mate;
    showAction?: boolean;
    type?: "rank" | "retry";
    isSelect?: boolean;
    showTitle?: boolean;
    resetObjectiveWhenChangeMember?: boolean;
  }>(),
  {
    resetObjectiveWhenChangeMember: true,
  }
);

const emit = defineEmits<{
  (e: "update:activeMate", mate?: Mate): void;
}>();

const exclude = computed(() => {
  const selectMateIds = props.dispatchMission.dispatchMemberzz?.map(
    (item) => item.mate!.id
  );
  return [...(selectMateIds || []), props.activeMate?.id || 0];
});

const members = computed(() => {
  const { dispatchMission } = props;
  return [...(dispatchMission.dispatchMemberzz || [])].sort((a, b) => {
    if (a.type === DispatchMemberType.Leader) {
      return -1;
    }
    if (b.type === DispatchMemberType.Leader) {
      return 1;
    }
    return 0;
  });
});

const payerHtml = computed(() => {
  if (route.name !== "missionDetail" || props.isEdit) return "";
  if (members.value.length <= 1) return "";

  const leader = members.value[0];

  let result = ``;

  for (let i = 1; i < members.value.length; i++) {
    const member = members.value[i];
    if (member.payerType === DispatchMemberPayerType.Host) {
      result += `<p class="text-xs text-primary">${
        leader.mate!.name
      } 已为 ${useName(member.mate!.name)} 支付了能量块</p>`;
    }
  }

  return result;
});

const uiStore = useUI();
const clickAddLeader = () => {
  uiStore.popMateSelector({
    mateOnly: true,
    switchMate: false,
    callback: onLeaderMateSelect,
  });
};

const onLeaderMateSelect = (mate: Mate) => {
  emit("update:activeMate", mate);
  const dispatchMission = props.dispatchMission;
  dispatchMission.dispatchMemberzz = [
    {
      mate,
      type: DispatchMemberType.Leader,
    } as MateDispatchMember,
  ];
  dispatchMission.mateId = mate.id;
  uiStore.showMateSelector = false;
};

const clickAddMember = () => {
  showFriendMateSelect.value = true;
};

const clickRemoveMember = async (item: MateDispatchMember) => {
  const pass = props.resetObjectiveWhenChangeMember
    ? await checkAndInitObjective(props.dispatchMission)
    : true;
  if (!pass) return;

  const dispatchMission = props.dispatchMission;
  if (item.type === DispatchMemberType.Leader) {
    dispatchMission.dispatchMemberzz = [];
    dispatchMission.mateId = undefined;
    dispatchMission.carriedMailzz = [];
    emit("update:activeMate", undefined);
  } else {
    dispatchMission.dispatchMemberzz = dispatchMission.dispatchMemberzz?.filter(
      (v) => v.mate!.id !== item.mate!.id
    );
  }
};

const showFriendMateSelect = ref(false);

const onFriendMateSelect = async (mate: Mate, needCheck = true) => {
  if (needCheck) {
    const pass = props.resetObjectiveWhenChangeMember
      ? await checkAndInitObjective(props.dispatchMission)
      : true;
    if (!pass) return;
  }

  props.dispatchMission.dispatchMemberzz!.push({
    mate,
    type: mateStore.isMyMateById(mate.id)
      ? DispatchMemberType.SelfCharacter
      : DispatchMemberType.OthersCharacter,
  } as MateDispatchMember);
  showFriendMateSelect.value = false;
};

const clickMember = (item: MateDispatchMember) => {
  if (props.isEdit) return;
  if (!mateStore.isMyMateById(props.dispatchMission.mateId)) {
    return router.push({
      name: "mateHome",
      params: {
        uuid: item.mate!.uuid,
      },
    });
  }

  let sourceId, targetId;
  const myMate = props.dispatchMission.dispatchMemberzz?.find((v) =>
    mateStore.isMyMate(v.mate!.uuid)
  );
  if (myMate) {
    sourceId = myMate.mate?.id;
    targetId = item.mate?.id;
  }
  router.push({
    name: "relationshipOther",
    query: {
      sourceId,
      targetId,
    },
  });
};

const missionStore = useMission();
const { t } = useI18n();
const clickSettle = async (item: MateDispatchMember) => {
  const loading = showLoadingToast(t(`Message.loading`));
  try {
    await missionStore.settleMateDispatch(
      props.dispatchMission.id!,
      item.mateId
    );
    router.push({
      name: "missionJourneyItem",
      query: {
        dispatchUuid: props.dispatchMission.uuid,
        mateId: item.mateId,
      },
    });
  } finally {
    loading.close();
  }
};

const clickToDetail = (item: MateDispatchMember) => {
  router.push({
    name: "missionJourneyItem",
    query: {
      dispatchUuid: props.dispatchMission.uuid,
      mateId: item.mateId,
    },
  });
};

const clickPayerType = (item: MateDispatchMember) => {
  item.payerType =
    item.payerType === DispatchMemberPayerType.Host
      ? DispatchMemberPayerType.Self
      : DispatchMemberPayerType.Host;
};

watch(
  () => props.dispatchMission,
  () => {
    if (!props.activeMate) {
      const leader = props.dispatchMission.dispatchMemberzz?.find(
        (v) => v.type === DispatchMemberType.Leader
      );
      if (leader) {
        emit("update:activeMate", leader.mate);
      }
    }
  },
  {
    deep: true,
  }
);

const route = useRoute();
onMounted(() => {
  if (props.isSelect || route.name !== "missionEdit") return;
  const hostUuid = route.query.hostUuid as string;
  if (hostUuid) {
    const hostMate = mateStore.mateMap.get(hostUuid)!;
    onLeaderMateSelect(hostMate);
  }
  if (route.query.inviteeUuid) {
    mateStore.getOrFetchMate(route.query.inviteeUuid as string).then((v) => {
      onFriendMateSelect(v, false);
    });
  }
});
</script>
